import { toastError } from "../../../js/views/components/error";
import {
    appUrl,
    leadInfo,
    selectedAppointmentUnixTime,
    selectedCountry,
    setLeadInfo,
    setLeadTextId,
    visitorId,
    form,
    a2pConsentEnabled,
    smsConsentTransactional,
    smsConsentPromotional,
    termsAndPrivacyAccepted,
    setSmsConsentTransactional,
    setSmsConsentPromotional,
    setTermsAndPrivacyAccepted,
} from "../../../js/utils/variables";
import { renderUIEditInfoLead, } from "../actions/verifyInforAction";
import parsePhoneNumberFromString from "libphonenumber-js";
import { updateLeadPortal } from "../../../js/services/digitsCodeService";
import { appointmentItemsClickEventHandler } from "../actions/selectTimeActions";
import { loadAllQuestionsFlow, shouldTriggerAllQuestionsAfterValidation } from "../actions/allQuestionsFlow";
import { loadLanguageDropdownVerify, getLanguageId } from "../../views/components/languageDropdown";

var verifySimpleConsentChecked = false;

export function verifyInforListeners(lead) {

    renderUIEditInfoLead(lead)

    // Load language dropdown if enabled
    if (form?.show_language_dropdown) {
        loadLanguageDropdownVerify(lead?.language);
    }

    // Reset consent state for this flow
    verifySimpleConsentChecked = false;

    if (!leadInfo?.last_name || !lead?.first_name || !leadInfo?.phone) {
        document.querySelector('.verify-infor-continue__btn')?.classList.add('disabled');
    }

    /* On click enter */
    const screenPhone = document.querySelector('.verifyInformation__container');
    if (screenPhone) {
        screenPhone.addEventListener('keydown', handlePressEnter);
    }

    editInfoListener()

    // Initialize consent checkbox listeners for verify-info form
    initVerifyConsentListeners();
}

function initVerifyConsentListeners() {
    const container = document.querySelector('.verifyInformation__container');
    if (!container) return;

    if (a2pConsentEnabled) {
        // A2P mode: 3 checkboxes
        const transactionalCheckbox = container.querySelector('.sms-consent-transactional-checkbox');
        const promotionalCheckbox = container.querySelector('.sms-consent-promotional-checkbox');
        const termsPrivacyCheckbox = container.querySelector('.terms-privacy-checkbox');
        const transactionalRow = container.querySelector('.sms-consent-transactional-row');
        const promotionalRow = container.querySelector('.sms-consent-promotional-row');
        const termsPrivacyRow = container.querySelector('.terms-privacy-row');

        const handleTransactionalClick = (e) => {
            e.preventDefault();
            if (transactionalCheckbox) {
                transactionalCheckbox.classList.toggle('is-checked');
                setSmsConsentTransactional(transactionalCheckbox.classList.contains('is-checked'));
                transactionalRow?.classList.remove('invalid');
                checkContinueBtnState();
            }
        };

        const handlePromotionalClick = (e) => {
            e.preventDefault();
            if (promotionalCheckbox) {
                promotionalCheckbox.classList.toggle('is-checked');
                setSmsConsentPromotional(promotionalCheckbox.classList.contains('is-checked'));
                checkContinueBtnState();
            }
        };

        const handleTermsPrivacyClick = (e) => {
            if (e.target.closest('.terms-link') || e.target.closest('.privacy-link')) {
                return;
            }
            e.preventDefault();
            if (termsPrivacyCheckbox) {
                termsPrivacyCheckbox.classList.toggle('is-checked');
                setTermsAndPrivacyAccepted(termsPrivacyCheckbox.classList.contains('is-checked'));
                termsPrivacyRow?.classList.remove('invalid');
                checkContinueBtnState();
            }
        };

        if (transactionalRow && transactionalCheckbox) {
            transactionalRow.style.cursor = 'pointer';
            transactionalRow.onclick = handleTransactionalClick;
            transactionalCheckbox.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleTransactionalClick(e); }
            });
        }
        if (promotionalRow && promotionalCheckbox) {
            promotionalRow.style.cursor = 'pointer';
            promotionalRow.onclick = handlePromotionalClick;
            promotionalCheckbox.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handlePromotionalClick(e); }
            });
        }
        if (termsPrivacyRow && termsPrivacyCheckbox) {
            termsPrivacyRow.style.cursor = 'pointer';
            termsPrivacyRow.onclick = handleTermsPrivacyClick;
            termsPrivacyCheckbox.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleTermsPrivacyClick(e); }
            });
        }
    } else {
        // Simple mode: single checkbox
        const simpleCheckbox = container.querySelector('.sms-consent-simple-checkbox');
        const simpleRow = container.querySelector('.sms-consent-simple-row');

        const handleSimpleClick = (e) => {
            e.preventDefault();
            if (simpleCheckbox) {
                simpleCheckbox.classList.toggle('is-checked');
                verifySimpleConsentChecked = simpleCheckbox.classList.contains('is-checked');
                if (verifySimpleConsentChecked) {
                    setSmsConsentTransactional(true);
                    setTermsAndPrivacyAccepted(true);
                } else {
                    setSmsConsentTransactional(false);
                    setTermsAndPrivacyAccepted(false);
                }
                simpleRow?.classList.remove('invalid');
                checkContinueBtnState();
            }
        };

        if (simpleRow && simpleCheckbox) {
            simpleRow.style.cursor = 'pointer';
            simpleRow.onclick = handleSimpleClick;
            simpleCheckbox.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleSimpleClick(e); }
            });
        }
    }
}

function editInfoListener() {
    const screenPhone = document.querySelector('.verifyInformation__container');
    const verify = screenPhone.querySelector('.verify-infor__actions .verify-infor-continue__btn')
    if (verify) {
        verify.addEventListener("click", onClickContinueBtn)
    }
    document.querySelectorAll('.verifyInformation__container input').forEach((element) => {
        element.addEventListener('input', checkContinueBtnState, false);
        element.addEventListener('keydown', onKeyDownInput, false);
    });
    let datepicker = flatpickr("#dobDatepicker", {
        maxDate: 'today',
        dateFormat: "M d, Y",
        altInput: true,
        altFormat: "F j, Y",
    });
}

async function onClickContinueBtn() {
    let loaderIcon = document.querySelector('.verify-infor-continue__btn .loader__icon');
    try {
        document.querySelector('.verify-infor-continue__btn')?.classList.add('disabled');
        document.querySelector('.verify-infor-continue__btn .loading__wrapper')?.classList.remove('hidden');
        if (loaderIcon) {
            loaderIcon.innerHTML = `<img src="${appUrl}/assets/icons/rolling.png" />`;
        }
        let nameInputDoms = document.querySelectorAll('.verifyInformation__container input');
        let fullName = nameInputDoms[0].value.trim();
        const [first_name, last_name] = splitFullName(fullName);

        // Get language value from dropdown
        const languageInput = document.querySelector('.verifyInformation__container #languageVerify');
        const selectedLanguageValue = languageInput ? languageInput.value.trim() : '';
        const languageId = selectedLanguageValue ? getLanguageId(selectedLanguageValue) : null;

        let data = {
            ...(first_name && { first_name }),
            ...(last_name && { last_name }),
            ...(nameInputDoms[1].value && nameInputDoms[1].value !== leadInfo?.email && { email: nameInputDoms[1].value }),
            ...(parsePhoneNumberFromString(nameInputDoms[2].value, selectedCountry).number !== leadInfo?.phone && { phone: parsePhoneNumberFromString(nameInputDoms[2].value, selectedCountry).number }),
            ...(languageId && { language: languageId }),
            ...(visitorId && { visitor_id: visitorId }),
            sms_consent_transactional: smsConsentTransactional,
            sms_consent_promotional: smsConsentPromotional,
            terms_and_privacy_accepted: termsAndPrivacyAccepted,
        };
        const leadTextId = leadInfo?.text_id;
        if (leadTextId && Object.keys(data).length) {
            const updatedLead = await updateLeadPortal(leadTextId, data);
            if (updatedLead?.data) {
                setLeadInfo(updatedLead.data);
                if (updatedLead.data.text_id) {
                    setLeadTextId(updatedLead.data.text_id);
                }
            }
        }
        if (shouldTriggerAllQuestionsAfterValidation()) {
            loadAllQuestionsFlow();
            return;
        }
        await appointmentItemsClickEventHandler(selectedAppointmentUnixTime, data);

    } catch (error) {
        toastError(error.response?.data?.message);
        const { email } = (error.response?.data?.errors || {});

        if (email) {
            document.querySelector(".verifyInformation__container .email-input ")?.classList?.add("invalid");
        }

    } finally {
        if (loaderIcon) {
            loaderIcon.innerHTML = '<i class="ri-arrow-right-line"></i>';
        }
        document.querySelector('.verify-infor-continue__btn .loading__wrapper')?.classList.add('hidden');
        document.querySelector('.verify-infor-continue__btn')?.classList.remove('disabled');
    }
}

function checkContinueBtnState(e) {

    const container = document.querySelector(".verifyInformation__container");

    if (container) {
        const target = e?.target;
        let value = target?.value

        const classNames = [
            { className: "full_name-input", type: "full_name-input" },
            { className: "phone-input", type: "phone-input" },
        ];

        const inputErr = classNames
            .filter(({ className }) => target?.closest(`.${className}`))
            .map(({ type }) => type);


        inputErr.forEach((type) => {
            const element = container.querySelector(`.${type}`);
            if (type === "full_name-input") {
                if (value && !validateFullName(value)) {
                    value = "";
                }
            }
            if (value) {
                element?.classList?.contains("invalid") && element.classList.remove("invalid");
            } else {
                !element?.classList?.contains("invalid") && element.classList.add("invalid");
            }
        });
    }

    let continueBtnDom = document.querySelector('.verifyInformation__container .verify-infor-continue__btn');
    if (validateData()) {
        continueBtnDom?.classList.remove('disabled');
    } else {
        continueBtnDom?.classList.add('disabled');
    }
}


function onKeyDownInput(event) {
    if (event.key === 'Tab') {
        event.stopPropagation();
    }
}


function handlePressEnter(event) {
    event.stopPropagation();
    if (event.key === 'Enter' && !document.querySelector(`.verifyInformation__container .verify-infor-continue__btn`).classList.contains('disabled')) {
        document.querySelector(`.verifyInformation__container .verify-infor-continue__btn`).click();
    }
}

export function resetPageRegisterNewPatientsFormData() {
    document.querySelectorAll('.verifyInformation__container input').forEach((element) => { element.value = ''; });
}


function isValidEmail(email) {
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    return emailRegex.test(email);
}

function validateFullName(fullName) {
    return fullName.split(" ")?.filter(i => !!i).length >= 2;
}

export function validateData() {
    let fullNameDom = document.querySelector('.verifyInformation__container .full_name-input input');
    let emailDom = document.querySelector('.verifyInformation__container .email-input input');
    let phoneDom = document.querySelector('.verifyInformation__container .phone-input input');

    if (!validateFullName(fullNameDom.value)) return false;
    if ((emailDom.value && !isValidEmail(emailDom.value))) {
        document.querySelector(".verifyInformation__container .email-input ")?.classList?.add("invalid");
        return false;
    }

    if (emailDom.value === "") {
        document.querySelector(".verifyInformation__container .email-input ")?.classList?.remove("invalid");
    }

    if (!phoneDom.value || phoneDom.value.length === 0) return false;

    // Check consent
    if (a2pConsentEnabled) {
        if (!smsConsentTransactional || !termsAndPrivacyAccepted) return false;
    }

    return true;
}


function splitFullName(fullName) {
    let nameParts = fullName.split(" ");
    let first_name = nameParts[0];
    let last_name = nameParts.slice(1).join(" ");
    return [first_name, last_name];
}
